import { Card, Chip, Grid2, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IZoneSchedule } from "../../../../../Domain/Types/FloorPlan/ZoneSchedule";
import { IEquipmentInventory } from "../../../../../Domain/Types/FloorPlan/Equipment.type";
import ServiceBookableEquipmentTable from "./BookableEquipmentTable";
import {
  AssignedBookableEquipment,
  BookableEquipmentIds
} from "../../../../../Domain/Types/FloorPlan/BookableEquipmentAssignment.type";

type Props = {
  zoneSchedule: IZoneSchedule;
  bookableEquipment: IEquipmentInventory[] | undefined;
  assignedBookableEquipment: AssignedBookableEquipment[];
  onChangeConfService: (
    id: number,
    service: { bookableEquipments: BookableEquipmentIds[] }
  ) => void;
  onClose: () => void;
};

export const BookableEquipmentDialogContent = ({
  zoneSchedule,
  bookableEquipment,
  assignedBookableEquipment,
  onChangeConfService,
  onClose
}: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      sx={{ p: 2, width: "75vw", overflow: "auto", maxHeight: "80%", backgroundImage: "unset" }}
      data-testid={"bookable-equipment-assignment-card"}
    >
      <Stack direction={"column"} gap={2}>
        {/* header of dialog content */}
        <Grid2 container display={"grid"} data-testid="bookable-equipment-dialog-content-header">
          <Grid2 container display={"flex"} alignItems={"center"} columnGap={2}>
            <Typography align={"left"} lineHeight={2.5} variant={"h6"}>
              {t("BookableEquipmentDialogContentTitle")}
            </Typography>
            <Chip label={zoneSchedule.inventory?.name ?? "Zone"} />
          </Grid2>
          <Typography align={"left"} lineHeight={2} variant={"subtitle2"}>
            {t("BookableEquipmentDialogContentSubTitle")}
          </Typography>
        </Grid2>

        {/* parent element of display and select options */}
        <Grid2
          container
          data-testid="bookable-equipment-assignment-parentEl"
          alignSelf={"center"}
          sx={{ width: "100%", maxHeight: "80vh" }}
        >
          <ServiceBookableEquipmentTable
            zoneSchedule={zoneSchedule}
            bookableEquipment={bookableEquipment}
            assignedBookableEquipment={assignedBookableEquipment}
            onClose={onClose}
            onChangeConfService={onChangeConfService}
          />
        </Grid2>
      </Stack>
    </Card>
  );
};
